export const NavigationExternalLink: React.FC<{ href: string }> = (props) => (
  <a
    rel="noreferrer"
    target="_blank"
    style={{
      color: 'inherit',
      textDecoration: 'none'
    }}
    {...props}
  >
    {props.children}
  </a>
);
